<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='角色信息管理' label2="新增角色信息" url="/system/role/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <el-row>
          <el-col :span="12">
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">角色级别：</label>
              <div class="col-lg-8">
                <el-form-item prop="rolelevel" :rules="{required: true, message: '角色级别不能为空', trigger: 'blur'}">
                  <el-select v-model="form.rolelevel" style="width: 100%;">
                    <el-option v-for="item in this.$utils.RoleLevel" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">角色名称：</label>
              <div class="col-lg-8">
                <el-form-item prop="rolename" :rules="{required: true, message: '角色名称不能为空', trigger: 'blur'}">
                  <el-input v-model="form.rolename"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">角色描述：</label>
              <div class="col-lg-8">
                <el-input v-model="form.roledesc"></el-input>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">单位范围：</label>
              <div class="col-lg-8">
                <FormHospitalMultipleSelect :multiple="multiple" v-model="form.hosrange"></FormHospitalMultipleSelect>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">人员类型范围：</label>
              <div class="col-lg-8">
                <FormDictItemMultipleSelect :dictid="this.$utils.DictEnum.usertype" v-model="form.usertyperange"></FormDictItemMultipleSelect>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">权限范围：</label>
              <div class="col-lg-8">
                <el-tree :data="tableData" show-checkbox default-expand-all node-key="id" ref="tree" highlight-current :props="defaultProps" @check-change="getCheckedItems"></el-tree>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="m-form__actions m-form__actions--solid">
          <div class="row">
            <div class="col-lg-12" style="text-align: center;">
              <SaveButton :url="saveUrl" back="/system/role/list"></SaveButton>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoleAdd',
  data () {
    return {
      form: {
        rolename: '',
        roletype: 2,
        rolelevel: 1,
        roledesc: '',
        hosrange: [],
        usertyperange: [],
        token: '',
        rolepower: ''
      },
      tableData: [{}],
      multiple: true,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      saveUrl: this.$utils.Url.system + '/systemapi/role/add'
    }
  },
  methods: {
    getCheckedItems: function () {
      this.form.rolepower = this.$refs.tree.getCheckedKeys()
    }
  },
  mounted: function () {
    this.form.token = sessionStorage.getItem('token')
    var that = this
    var args = {
      token: this.form.token
    }
    // 加载权限树
    this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/role/powerlist', args, function (d) {
      that.tableData = d.Data
    }, null, null)
  }
}
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }
</style>
